import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField, Typography } from '@mui/material';

import { getCountries } from '../../../services/addMemberApi';
import { Root, classes } from './utils';
import { ADD_MEMBER } from '../../../constants/staticContent';

const CountryDropdown = ({
  countryList,
  setCountryList,
  countryValid,
  setCountryValid,
  setFormData,
}) => {
  const [options, setOptions] = useState([]);
  const fetchData = async () => {
    const response = await getCountries();
    if (response) {
      setOptions(
        response?.map((item, index) => ({
          key: index,
          label: item?.country_name,
        })),
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      country: countryList?.label,
    }));
  }, [countryList, setFormData]);

  return (
    <Root>
      <Autocomplete
        fullWidth
        disableClearable={!options.length}
        size="medium"
        disablePortal
        id="combo-box-demo"
        options={options}
        onChange={(event, newValue) => {
          setCountryList(newValue);
          setCountryValid(true);
        }}
        value={countryList}
        renderInput={(params) => (
          <TextField {...params} error={!countryValid} label="Country" />
        )}
      />
      {!countryValid && (
        <Typography variant="caption" className={classes.countryDropdownTypo}>
          {ADD_MEMBER.COUNTRY_DROPDOWN}
        </Typography>
      )}{' '}
    </Root>
  );
};
CountryDropdown.propTypes = {
  countryList: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  setCountryList: PropTypes.func.isRequired,
  countryValid: PropTypes.bool.isRequired,
  setCountryValid: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default CountryDropdown;
